import React from "react";

export function Presets({
	footerPresets,
}: {
	footerPresets?: React.ReactNode[];
}) {
	if (!footerPresets) {
		return null;
	}

	return <section className="search-presets">{footerPresets}</section>;
}
